import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { submitPopupNotification } from 'Features/Learning/PopupNotification/Utils/PopupNotificationUtils';
import { resetState, setField } from 'Features/Learning/PopupNotification/addPopupNotificationSlice';
import DropzoneCommon from 'Component/Learning/Common/Upload/Dropzone';
import Swal from 'sweetalert2';

const PopupNotificationPost = ({ modal, toggle, onSuccess }) => {
  const dispatch = useDispatch();
  const data = useSelector(state => state.addPopupNotification)

  const handleSuccess = () => {
    dispatch(resetState());
    onSuccess?.();
    toggle();
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const required = [
      { key: 'image', label: 'Gambar Popup Notification' },
      { key: 'url', label: 'URL Popup Notification' },
    ];

    const missing = required.find(f => {
      const val = data?.[f.key];
      return val === undefined || val === null || String(val).trim() === '';
    });

    if (missing) {
      return Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: `${missing.label} tidak boleh kosong.`,
      });
    }

    // pastikan is_show terset (default '1' jika belum dipilih)
    const payload = {
      ...data,
      is_show: data?.is_show === undefined || data?.is_show === null || String(data?.is_show).trim() === '' ? '1' : String(data.is_show)
    };

    // dispatch sama untuk create/update pada implementasi saat ini
    dispatch(submitPopupNotification({ ...payload, successCallback: handleSuccess }));
  };

  const handleChangeImage = ({ meta, file }, status) => {
    if (status === 'removed') {
      dispatch(setField({ field: 'image', value: '' }));
    } else if (status === 'done') {
      dispatch(setField({ field: 'image', value: file }));
    }
  };

  return (
    <Modal isOpen={modal} toggle={toggle} size='md' backdrop="static" keyboard={false} autoFocus>
      <ModalHeader toggle={toggle}>Tambah Popup Notification</ModalHeader>
      <ModalBody>
        <Form>
          {/* Tampilkan preview image existing saat mode edit agar user tahu file lama tetap terpasang. */}
          {data?.isUpdate && typeof data?.image === 'string' && data?.image.trim() !== '' && (
            <div className="mt-2">
              <img
                src={data.image}
                alt="popup-notification-existing"
                style={{ width: '180px', maxWidth: '100%', height: 'auto', borderRadius: '6px' }}
              />
            </div>
          )}

          <FormGroup>
            <DropzoneCommon label={'Image'} inputContent={data?.image ? 'Image tersedia (opsional upload ulang)' : 'Silahkan upload gambar.'} handleChangeStatus={handleChangeImage} accept="image/*" />
          </FormGroup>
          <FormGroup>
            <Label for="url">URL Popup Notification</Label>
            <Input type="url" title="url" id="url" placeholder="Masukkan URL Popup Notification" value={data?.url} onChange={(e) => dispatch(setField({ field: 'url', value: e.target.value }))} />
          </FormGroup>
          <FormGroup>
            <Label for="targetPage" style={{ fontWeight: 'bold' }}>Ditampilkan di:</Label>
            <select
              id="targetPage"
              className="form-control selectpicker"
              name="target_page"
              value={data.target_page || 'home'}
              onChange={e => dispatch(setField({ field: 'target_page', value: e.target.value }))}
            >
              <option value="home">Home</option>
              <option value="overview">Overview</option>
              <option value="both">Keduanya (Home + Overview)</option>
            </select>
          </FormGroup>
          <FormGroup className="mb-3">
            <Label style={{ fontWeight: 'bold' }}>Tampilkan Popup Notification:</Label>
            <div className="m-checkbox-inline">
              <Label for="popup_true">
                <Input className="radio_animated" id="popup_true" type="radio" name="is_show" value="1"
                  checked={data.is_show === 1 || data.is_show === '1'}
                  onChange={e => dispatch(setField({ field: 'is_show', value: e.target.value }))}
                />
                YA
              </Label>
              <Label for="popup_false">
                <Input className="radio_animated" id="popup_false" type="radio" name="is_show" value="0"
                  checked={data.is_show === 0 || data.is_show === '0'}
                  onChange={e => dispatch(setField({ field: 'is_show', value: e.target.value }))}
                />
                TIDAK
              </Label>
            </div>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleSubmit}>
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PopupNotificationPost;